<template>
	<section class="page">
		<el-tabs v-model="activeName">
			<el-tab-pane label="库存" name="list">
				<div class="content-box">
					<div class="operator">
						<div class="operator-col">
							<warehouse-input v-model="filterWarehouse"></warehouse-input>
						</div>
						<div class="operator-col">
							<classify-input v-model="filterClassify" size="mini"></classify-input>
						</div>
						<div class="operator-col">
							<brand-input v-model="filterBrand"></brand-input>
						</div>
						<div class="operator-col">
							<season-input v-model="filterSeason"></season-input>
						</div>
						<div class="operator-col">
							<el-input
									size="mini"
									v-model="filterTableSearch"
									placeholder="SPU 名/码"
									suffix-icon="el-icon-search"
									clearable
							></el-input>
						</div>
						<div class="operator-col">
							<el-select
									size="mini"
									v-model="exportValue" placeholder="导出是否带图片">
								<el-option
										v-for="item in exportOptions"
										:key="item.value"
										:label="item.label"
										:value="item.value">
								</el-option>
							</el-select>
						</div>
						<div class="operator-col">
							<el-button size="mini" type="primary" @click="doInventoryExport(editorDataModel)">导出</el-button>
						</div>
					</div>

					<div class="operator">
						<div class="operator-col">
							<el-input
								size="mini"
								v-model="filterTableSearchColor"
								placeholder="颜色 名/码"
								suffix-icon="el-icon-search"
								clearable
							></el-input>
						</div>
						<div class="operator-col">
							<editor-relateid
								size="mini"
								v-model="filterModel"
								data-model-name="Model"
								:name-fields="['name']"
								:params="{allowCreate:false,placeholder:'搜索尺寸'}"
							></editor-relateid>
						</div>
            <div class="operator-col">
              <el-select
                  size="mini" v-model="filterMetagender.value" placeholder="性别" @change="sexChange">
                <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                </el-option>
              </el-select>
            </div>
						<div class="operator-col">
							<bool-filter
								size="mini"
								v-model="filterIsSpecial.value"
								suffix-icon="el-icon-search"
								clearable
								data-model-name="Item"
								field="is_special"
								field-name="特价"
							></bool-filter>
						</div>
            <div class="operator-col">
              <bool-filter
                           size="mini"
                           v-model="filterIsStar.value"
                           suffix-icon="el-icon-search"
                           clearable
                           data-model-name="Item"
                           field="is_star"
                           field-name="星标"
              ></bool-filter>
            </div>
					</div>
					<sum-table
						ref="sumTable"
						:data-model="editorDataModel"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:fields="sumFields"
						:warehouse-filter="filterWarehouse || {_id:''}"
            :color-filter="filterTableSearchColor"
						list-url="inventory/sum_all_stocks"
					></sum-table>
					<stock-table
						:list-ops="[]"
						:has-delete="false"
						ref="listTable"
						:data-model="editorDataModel"
						@doedit="handleEdit($event)"
						@dosort="handleSort"
						:search-filter="filterTableSearch"
						:kv-filter="kvFilter"
						:warehouse-filter="filterWarehouse"
            :color-filter="filterTableSearchColor"
						list-url="inventory/list_all_stocks/"
					></stock-table>
				</div>
			</el-tab-pane>
		</el-tabs>
	</section>
</template>

<script>
import CurdPage from "@/mixins/CurdPage.js";
import Filters from "@/mixins/Filters.js";
import FilterSeason from "@/mixins/Filter/FilterSeason.js";
import FilterModel from "@/mixins/Filter/FilterModel.js";
import FilterClassify from "@/mixins/Filter/FilterClassify.js";
import FilterWarehouse from "@/mixins/Filter/FilterWarehouse.js";

import StockTable from "@/views/Inventory/subs/StockTable.vue";
import SumTable from "@/components/SumTable.vue";
import { mapState, mapGetters, mapMutations } from "vuex";
import axios from "axios";

export default {
	mixins: [CurdPage, Filters, FilterSeason, FilterModel, FilterClassify, FilterWarehouse],
	components: {
		StockTable,
		SumTable,
	},
	data() {
		return {
			loadings: {
				main: false,
				sums: false,
			},
      options: [{
        value: '',
        label: '全部'
      },{
        value: 0,
        label: '不区分性别'
      }, {
        value: 1,
        label: '男'
      }, {
        value: 2,
        label: '女'
      }],
      value:'',

			editorDataModel: "Item",
			filterIsSpecial: { field: "is_special", value: null },
      filterMetagender: { field: "meta_gender", value: null},
      filterIsStar: { field: "is_star", value: null},

			filterTableSearchColor: "",
		};
	},
	computed: {
		...mapState(["userPrivilegeMapping"]),

		productFilters() {
			let filter = [];
			if (this.filterBrand._id != "") {
				filter.push({ k: "brand", t: "_id", v: this.filterBrand._id });
			}
			if (this.filterClassify.length != 0) {
				filter.push({
					k: "classify",
					t: "classify",
					v: this.filterClassify[this.filterClassify.length - 1]._id,
				});
			}
			return filter;
		},
		sumFields() {
			return [
				{
					name: "count",
					title: "种类",
				},
				{
					name: "sum_amount",
					title: "总数量",
				},
				{
					name: "sum_cost_total",
					title: "总金额",
					prefix: this.$root.currencyCode,
				},
        {
          name: "sum_price_1",
          title: "零售价总计",
          prefix: this.$root.currencyCode,
        },
			].filter(item => {
				if (!this.userPrivilegeMapping[59] && item.name == "sum_cost_total") {
					return false;
				}
				if (!this.userPrivilegeMapping[53] && item.name == "sum_amount") {
					return false;
				}
				return true;
			});
		},
	},
	watch: {
		"filterIsSpecial.value": {
			handler(newVal) {
				let val = this.filterIsSpecial;
				if (val.value != null && val.value !== "") {
					this.$set(this.kvFilter, val.field, {
						k: val.field,
						t: "int",
						v: val.value,
					});
				} else {
					this.$delete(this.kvFilter, val.field);
				}
			},
			immediate: true,
		},
    "filterMetagender.value": {
      handler(newVal) {
        let val = this.filterMetagender;
        console.log(this.filterMetagender)
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, {
            k: val.field,
            t: "int",
            v: val.value,
          });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
    "filterIsStar.value": {
      handler(newVal) {
        let val = this.filterIsStar;
        if (val.value != null && val.value !== "") {
          this.$set(this.kvFilter, val.field, {
            k: val.field,
            t: "int",
            v: val.value,
          });
        } else {
          this.$delete(this.kvFilter, val.field);
        }
      },
      immediate: true,
    },
    "filterTableSearchColor":{
      handler(newVal) {
        let val = this.filterTableSearchColor;
      },
    },
	},
  methods:{
    sexChange(){
      console.log(1)
      this.$axios
          .post("/inventory/list_all_stocks/", {sex:1})
          .then(json => {
            console.log(json)
          })
          .catch(json => {
            console.log(json)
          });
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
